export const EN_MEDIA_STRINGS = {
  IMAGE: 'Image',
  CONTENT_TYPE: 'Content Type',
  IMAGE_DESCRIPTION_HINT:
    'Describe what is in the asset. In most cases, this will be read as alt text when a user is using a screen reader.',
  IMAGE_TITLE_HINT:
    "Text used for the image's HTML title attribute. In most cases, it appears as a tooltip when users hover their mouse over the image.",
  IMAGE_FILE: 'Image File',
  PDF_DESCRIPTION_HINT:
    'Describe what is in the asset. In most cases, this will be read as alt text when a user is using a screen reader.',
  PDF_TITLE_HINT: 'The title of the PDF',
};
